module.exports = __webpack_public_path__ + "img/home1.a47a7c62.png";